

























import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Tabs",
  props: {
    value: {
      type: [String, Number] as PropType<Props["value"]>,
      required: true
    }
  },
  data() {
    return {
      panes: []
    };
  },
  mounted() {
    this.calcPaneInstances();
  },
  methods: {
    calcPaneInstances() {
      this.panes = (this.$slots.default as any).filter(
        (vnode: any) =>
          vnode.tag &&
          vnode.componentOptions &&
          vnode.componentOptions.Ctor.options.name === "TabPane"
      );
    },
    activePane(name) {
      return this.value === name;
    },
    handleClick(name) {
      this.$emit("input", name);
      this.$emit("click", name);
    }
  }
});
